import Vue from "vue";
var store = Vue.observable({
  manualReadOnly: false
});
Vue.mixin({
  computed: {
    GlobalReadOnly: {
      get: function get() {
        return store.manualReadOnly || this.$route.meta.readOnly == true;
      },
      set: function set(v) {
        store.manualReadOnly = v;
      }
    }
  }
});
export default {
  SetReadOnlyValue: function SetReadOnlyValue(value) {
    store.manualReadOnly = value;
  }
};